import { Platform, Linking } from 'react-native';
import InAppBrowser from 'react-native-inappbrowser-reborn';
export const openTclLink = async (action, _datastore, { navigate }) => {
    if (Platform.OS === 'web') {
        const url = 'https://www.tatacapital.com/';
        const height = 650;
        const width = 650;
        const left = (window.innerWidth - width) / 2;
        const top = (window.innerHeight - height) / 2;
        window.open(url, "_blank", "width=" + width + ", height=" + height + ", top=" + top + ", left=" + left);
    }
    else {
        try {
            const isAvailable = await InAppBrowser.isAvailable();
            if (isAvailable) {
                await InAppBrowser.open('https://www.tatacapital.com/', {
                    dismissButtonStyle: 'cancel',
                    preferredBarTintColor: '#453AA4',
                    preferredControlTintColor: 'white',
                    readerMode: false,
                    animated: true,
                    modalPresentationStyle: 'fullScreen',
                    modalTransitionStyle: 'coverVertical',
                    modalEnabled: true,
                    enableBarCollapsing: false,
                });
            }
            else {
                Linking.openURL('https://www.tatacapital.com/');
            }
        }
        catch (error) {
            console.error(error);
        }
    }
};
export const openBajajLink = async (action, _datastore, { navigate }) => {
    if (Platform.OS === 'web') {
        const url = 'https://www.bajajfinserv.in/bajaj-finserv-partners';
        const height = 650;
        const width = 650;
        const left = (window.innerWidth - width) / 2;
        const top = (window.innerHeight - height) / 2;
        window.open(url, "_blank", "width=" + width + ", height=" + height + ", top=" + top + ", left=" + left);
    }
    else {
        try {
            const isAvailable = await InAppBrowser.isAvailable();
            if (isAvailable) {
                await InAppBrowser.open('https://www.bajajfinserv.in/bajaj-finserv-partners', {
                    dismissButtonStyle: 'cancel',
                    preferredBarTintColor: '#453AA4',
                    preferredControlTintColor: 'white',
                    readerMode: false,
                    animated: true,
                    modalPresentationStyle: 'fullScreen',
                    modalTransitionStyle: 'coverVertical',
                    modalEnabled: true,
                    enableBarCollapsing: false,
                });
            }
            else {
                Linking.openURL('https://www.bajajfinserv.in/bajaj-finserv-partners');
            }
        }
        catch (error) {
            console.error(error);
        }
    }
};
export const openDSPLink = async (action, _datastore, { navigate }) => {
    if (Platform.OS === 'web') {
        const url = 'https://dspfin.com/';
        const height = 650;
        const width = 650;
        const left = (window.innerWidth - width) / 2;
        const top = (window.innerHeight - height) / 2;
        window.open(url, "_blank", "width=" + width + ", height=" + height + ", top=" + top + ", left=" + left);
    }
    else {
        try {
            const isAvailable = await InAppBrowser.isAvailable();
            if (isAvailable) {
                await InAppBrowser.open('https://dspfin.com/', {
                    dismissButtonStyle: 'cancel',
                    preferredBarTintColor: '#453AA4',
                    preferredControlTintColor: 'white',
                    readerMode: false,
                    animated: true,
                    modalPresentationStyle: 'fullScreen',
                    modalTransitionStyle: 'coverVertical',
                    modalEnabled: true,
                    enableBarCollapsing: false,
                });
            }
            else {
                Linking.openURL('https://dspfin.com/');
            }
        }
        catch (error) {
            console.error(error);
        }
    }
};
export const goBack = async (action, _datastore, { goBack }) => {
    goBack();
};
export const openBajajLoanAgainstMutualFundsLink = async (action, _datastore, { navigate }) => {
    if (Platform.OS === 'web') {
        const url = 'https://www.bajajfinserv.in/loan-against-mutual-funds';
        const height = 650;
        const width = 650;
        const left = (window.innerWidth - width) / 2;
        const top = (window.innerHeight - height) / 2;
        window.open(url, "_blank", "width=" + width + ", height=" + height + ", top=" + top + ", left=" + left);
    }
    else {
        try {
            const isAvailable = await InAppBrowser.isAvailable();
            if (isAvailable) {
                await InAppBrowser.open('https://www.bajajfinserv.in/loan-against-mutual-funds', {
                    dismissButtonStyle: 'cancel',
                    preferredBarTintColor: '#453AA4',
                    preferredControlTintColor: 'white',
                    readerMode: false,
                    animated: true,
                    modalPresentationStyle: 'fullScreen',
                    modalTransitionStyle: 'coverVertical',
                    modalEnabled: true,
                    enableBarCollapsing: false,
                });
            }
            else {
                Linking.openURL('https://www.bajajfinserv.in/loan-against-mutual-funds');
            }
        }
        catch (error) {
            console.error(error);
        }
    }
};
